import { render, staticRenderFns } from "./ItemImage.vue?vue&type=template&id=304a6ae0&scoped=true&lang=pug&"
import script from "./ItemImage.vue?vue&type=script&lang=js&"
export * from "./ItemImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a6ae0",
  null
  
)

export default component.exports